// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fd73d190","455":"46e2a997","977":"003201e9"}[chunkId] + ".chunk.js";
};